import { UTSLocale } from "@smile2impress/attraction-constants";

import france from "../../../content/relaunch/common/france";
import italy from "../../../content/relaunch/common/italy";
import portugal from "../../../content/relaunch/common/portugal";
import spain from "../../../content/relaunch/common/spain";
import uk from "../../../content/relaunch/common/uk";
import ukraine from "../../../content/relaunch/common/ukraine";
import us from "../../../content/relaunch/common/us";
import nl from "../../../content/relaunch/common/nl";
import sweden from "../../../content/relaunch/common/sweden";
import germany from "../../../content/relaunch/common/germany";
import denmark from "../../../content/relaunch/common/denmark";

export const dictionary = (locale: UTSLocale) => {
    switch (locale) {
        case UTSLocale.FRANCE_FR:
            return france;
        case UTSLocale.ITALY_IT:
            return italy;
        case UTSLocale.PORTUGAL_PT:
            return portugal;
        case UTSLocale.SPAIN_ES:
            return spain;
        case UTSLocale.GB_EN:
            return uk;
        case UTSLocale.UKRAINE_UK:
            return ukraine;
        case UTSLocale.US_EN:
            return us;
        case UTSLocale.NL_NL:
            return nl;
        case UTSLocale.SWEDEN_SE:
            return sweden;
        case UTSLocale.GERMANY_DE:
            return germany;
        case UTSLocale.DENMARK_DK:
            return denmark;
        default:
            return spain;
    }
};

export { default as BaseLayout } from "./RelaunchLayout";
